import { omit } from 'es-toolkit/compat';
import type { UserProfile } from 'oidc-client-ts';

import type { UserProfile as CustomUserProfile } from './loginSlice';

const stripSnakeProps = (profile: UserProfile) => omit(profile, ['family_name', 'given_name']);

// TODO: Depending on your client subscriptions you may want to map
//       additional properties from the OAuth profile
export const mapUserProfile = (profile: UserProfile): CustomUserProfile => ({
    sub: profile.sub,
    azp: profile.azp,
    givenName: profile.given_name,
    familyName: profile.family_name,
    name: profile.name,
    locale: profile.locale,
    email: profile.email,
    ...stripSnakeProps(profile),
});
